module.exports = __webpack_public_path__ + "front/img/b42.d1a5d1e2.jpg";